import _ from 'lodash';
import WebServices from '../WebServices';
import { showSnackBarMessage } from './AppInfoActions';
import {
    FUNCTIONS_SELECT_FUNCTION, PROCEDURE_ADD, FUNCTION_DETAILS_FETCH, FUNCTION_DETAILS_FETCH_ERROR, FUNCTION_DETAILS_FETCH_SUCCESS, PROCEDURE_EDIT, PROCEDURE_SAVE, PROCEDURE_SAVE_ERROR, PROCEDURE_SAVE_SUCCESS,
    FUNCTION_UPDATE_WORKFLOW, FUNCTION_UPDATE_WORKFLOW_SUCCESS, PROCEDURE_ADD_TO_WORKFLOW, PROCEDURE_ADD_TO_WORKFLOW_SUCCESS, PROCEDURE_ADD_TO_WORKFLOW_ERROR, PROCEDURES_ADD_ALL_TO_WORKFLOW, PROCEDURES_ADD_ALL_TO_WORKFLOW_ERROR, PROCEDURES_ADD_ALL_TO_WORKFLOW_SUCCESS,
    GBUS_FETCH,
    GBUS_FETCH_SUCCESS,
    GBUS_FETCH_ERROR,
    CREATE_DEVIATION,
} from './Types';
import { ErrorMessage } from 'formik';
import { selectFunction } from './FunctionsActions';


const saveProcedure = (procedure, saveProcedureCompleted = (success) => { }) => (dispatch, getState) => {
    dispatch({ type: PROCEDURE_SAVE, payload: procedure });

    let webServices = new WebServices();

    webServices.saveProcedure(procedure)
        .then((savedProcedure) => {

            const updatedProcedure = procedure.delete ? procedure : savedProcedure;

            if (procedure.revisionReason) {
                savedProcedure.revisionOfId = procedure.id;
            }

            dispatch({ type: PROCEDURE_SAVE_SUCCESS, payload: { ...updatedProcedure, functionId: procedure.functionId } });
            dispatch(showSnackBarMessage("Procedure Saved"));
            const aFunction = getState().functions.selectedFunction;
            dispatch(selectFunction(aFunction));
            saveProcedureCompleted(true);
        })
        .catch((error) => {
            dispatch({ type: PROCEDURE_SAVE_ERROR, payload: error });
            dispatch(showSnackBarMessage("Error Saving Procedure"));
            saveProcedureCompleted(false);
        });
}

const editProcedure = procedure => dispatch => {
    dispatch({ type: PROCEDURE_EDIT, payload: procedure });
}

const addProcedure = (projectId) => dispatch => {
    dispatch({ type: PROCEDURE_ADD, payload: { projectId } });
}

const addAllProceduresToFunctionWorkflow = (functionId, projectId) => (dispatch, getState) => {
    let webServices = new WebServices();
    dispatch({ type: PROCEDURES_ADD_ALL_TO_WORKFLOW });

    webServices.addAllProceduresToFunctionWorkflow(functionId, projectId)
        .then(async (data) => {
            dispatch(showSnackBarMessage("Procedures Added To Workflows", data.errorMessage));

            if (!data.errorMessage) {



                if (projectId) {
                    let projectSpecificProcedures = await webServices.getProjectSpecificProcedures({ gbuId: null, projectId, functionId });
                    dispatch({ type: PROCEDURES_ADD_ALL_TO_WORKFLOW_SUCCESS, payload: { projectSpecificProcedures } });

                } else {
                    const aFunction = getState().functions.selectedFunction;
                    dispatch(selectFunction(aFunction));
                    dispatch({ type: PROCEDURES_ADD_ALL_TO_WORKFLOW_SUCCESS });

                }

            } else {
                dispatch({ type: PROCEDURES_ADD_ALL_TO_WORKFLOW_ERROR });
            }


        })
        .catch((error) => {
            dispatch({ type: PROCEDURE_ADD_TO_WORKFLOW_ERROR, payload: error });
            dispatch(showSnackBarMessage("Error Adding Procedure to workflows"));
        });
}

const addProcedureToFunctionWorkflow = (procedureId, functionId, saveProcedureCompleted = (success) => { }) => (dispatch, getState) => {
    dispatch({ type: PROCEDURE_ADD_TO_WORKFLOW, payload: { procedureId, functionId } });

    let webServices = new WebServices();

    webServices.addProcedureToFunctionWorkflow(procedureId, functionId)
        .then((data) => {
            dispatch(showSnackBarMessage("Procedure Added To Workflows", data.errorMessage));

            if (!data.errorMessage) {
                dispatch({ type: PROCEDURE_ADD_TO_WORKFLOW_SUCCESS, payload: { ...data.result, functionId: functionId } });
                const aFunction = getState().functions.selectedFunction;
                dispatch(selectFunction(aFunction));
                saveProcedureCompleted(true);
            } else {
                dispatch({ type: PROCEDURE_ADD_TO_WORKFLOW_ERROR });
            }


        })
        .catch((error) => {
            dispatch({ type: PROCEDURE_ADD_TO_WORKFLOW_ERROR, payload: error });
            dispatch(showSnackBarMessage("Error Adding Procedure to workflows"));
            saveProcedureCompleted(false);
        });
}

const fetchGBUs = () => (dispatch) => {
    let webServices = new WebServices();
    dispatch({ type: GBUS_FETCH });

    webServices
        .getGBUs()
        .then((gbus) => {
            dispatch({ type: GBUS_FETCH_SUCCESS, payload: gbus });
        })
        .catch((error) => {
            dispatch({ type: GBUS_FETCH_ERROR, payload: error });
        });
};


export { editProcedure, addAllProceduresToFunctionWorkflow, addProcedure, saveProcedure, addProcedureToFunctionWorkflow, fetchGBUs };

